import { PricelistListPage } from '@/features/pricelist/pages/PricelistListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/pricelist/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["pricelist.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PricelistListPage,
})
